import { useSellerPortalBrands } from 'hooks'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { MultiSelect } from '../../MultiSelect'

type Props = {
  name: string
}

export function BrandSelector(props: Props) {
  const { formatMessage } = useIntl()
  const { name } = props
  const [searchTerm, setSearchTerm] = useState('')

  const { data: options, isLoading } = useSellerPortalBrands(searchTerm)

  return (
    <MultiSelect
      name={name}
      options={options ?? []}
      label={formatMessage({
        id: 'admin/promotions.form.scope.brands.select.placeholder',
      })}
      loadingOptions={isLoading}
      onSearch={setSearchTerm}
    />
  )
}
